import { useMemo } from "react";
import { IAutomationAppBase } from "@oqdo/automationapps/Abstractions/AutomationAppBase";
import { Breadcrumbs } from "baseui/breadcrumbs";
import { StyledLink } from "baseui/link";
import { LoadingView } from "../LoadingView";
import { useGetHierarchyByIdQuery } from "../../services/objects/objectsApi";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";

function HierarchyObjectNavigation(props: IAutomationAppBase) {
  const { data, isLoading, isSuccess, error } = useGetHierarchyByIdQuery({
    objectId: props.id,
    resourceGroupId: props.resourceGroupId,
  });

  const hierarchy = useMemo(() => {
    const h: HierarchyElement[] = (data ?? []).map((d: IAutomationAppBase) => {
      return { twinId: d.id, resourceGroupId: d.resourceGroupId, name: d.description };
    });
    h.push({
      twinId: props.id,
      resourceGroupId: props.resourceGroupId,
      name: props.description !== "" ? props.description : props.name,
    });

    return h;
  }, [data, props]);

  const objName = props.description !== "" ? props.description : props.name;
  const err: FetchBaseQueryError | undefined = error as FetchBaseQueryError | undefined;
  if (err && err.status === 403)
    return (
      <StyledLink href={`https://app.oqdo.io/objects/${props.resourceGroupId}/${props.id}`}>
        {objName} (UNAUTHORIZED to view)
      </StyledLink>
    );

  return (
    <LoadingView isLoading={isLoading} isSucess={isSuccess} error={error}>
      {isSuccess && (!data || data.length === 0) ? (
        <span>
          <StyledLink href={`https://app.oqdo.io/objects/${props.resourceGroupId}/${props.id}`}>{objName}</StyledLink>
        </span>
      ) : (
        <Breadcrumbs>
          {hierarchy.map((v) => (
            <StyledLink href={`https://app.oqdo.io/objects/${v.resourceGroupId}/${v.twinId}`}>{v.name}</StyledLink>
          ))}
        </Breadcrumbs>
      )}
    </LoadingView>
  );
}

export default HierarchyObjectNavigation;

interface HierarchyElement {
  twinId: string;
  resourceGroupId: string;
  name: string;
}
